exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  width: 100%;\n}\n.alert {\n  margin: 0.4rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group/wave-differs-warning/wave-differs-warning.component.less
// module id = ../../../../../src/app/dashboard/program-list/program/groups/group/wave-differs-warning/wave-differs-warning.component.less
// module chunks = 2